module.exports = "/assets/a7157048a38fac9c79c82c122be141fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/5Z.png
// module id = 2207
// module chunks = 0